import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function LineItemsTemperatureHandlingQuestionBubble() {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Temperature Requirements</T>
          <T size="xs" color="secondary">
            If your shipment requires protection from freezing, or refrigerated
            or frozen handling you can specify it here.
          </T>
          <T size="xs" color="secondary">
            Unfortunately we don&apos;t currently support refrigerated or frozen
            shipments
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/temperature-handling"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
